<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <b-row>
        <b-col cols="8">
          <RevisionesForm
            :data="formData"
            :errors="formErrors"
            :editing="isEditing"
            :assessor-select-options="assessorOptions"
            @update="updateForm"
          />
        </b-col>
      </b-row>

      <div v-if="!isEditing" class="mt-4">
        <BfButton @click="storeRevision">Guardar</BfButton>
      </div>
    </template>
  </PageWrap>
</template>

<script>
import RevisionesForm from '@/components/FormGroups/RevisionesForm';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import { chargeAPI, revisionesAPI } from '@/api';
import { mapState } from 'vuex';
import get from 'lodash.get';

export default {
  name: 'RevisionDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    const { chargeId = '' } = this.$route.query;

    return {
      chargeId,
      formData: {},
      formErrors: {},
      loadingData: false,
      retenido: {},
      assessorOptions: [],
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        await this.loadData();
      } else {
        if (!!this.chargeId === false) {
          this.$router.replace({ name: 'revisiones' });
        }

        await this.prepareForm();
        await this.getChargeData();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async storeRevision() {
      this.formData.tasador_abre_id = this.tasadorId;
      this.formData.encargos_id = this.chargeId;

      try {
        this.formErrors = {};
        const { data, message } = await revisionesAPI.create(this.formData);
        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'revision', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message: 'Existe un error con tus datos', type: 'error' });
      }
    },

    async loadData() {
      const { data, tasadores } = await revisionesAPI.get(this.id);

      this.formData = data;
      this.setAssessorOptions(tasadores);
    },

    async prepareForm() {
      const { data, tasadores } = await revisionesAPI.preCreate();

      this.formData = { ...this.formData, ...data };
      this.setAssessorOptions(tasadores);
    },

    async getChargeData() {
      const {
        data: [charge],
      } = await chargeAPI.get(this.chargeId);

      this.formData = {
        ...this.formData,
        encargo_numero: charge.numero_encargo,
        encargo_cliente_nombre: charge.empresa_cliente_nombre,
      };
    },

    setAssessorOptions(data) {
      if (data) {
        this.assessorOptions = data.map(({ clave, id }) => ({ label: clave, value: id }));
      }
    },


    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (key === 'externa' && value) {
        newData.tasador_asignado_id = null;
      }

      if (key === 'tasador_asignado_id' && value) {
        newData.externa = false;
      }

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await revisionesAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },
  },

  computed: {
    ...mapState({ tasadorId: ({ auth }) => get(auth, ['user', 'tasador_id']) }),
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Reclamación del encargo: ${this.formData.encargo_codigo || ''}` : 'Crear reclamación';
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
    RevisionesForm,
  },
};
</script>
